import React from "react";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Route, Switch } from "react-router-dom";
import Home from "./components/Home";
// import Investment from "./components/Investment";
// import Africa from "./components/Africa";
// import Governance from "./components/Governance";
// import Returns from "./components/Returns";
import Contact from "./components/Contact";
import About from "./components/About";
import Funder from "./components/Funder";
import Grantees from "./components/Grantees";
import Twiga from "./components/Grantees/components/Twiga";
import Teraco from "./components/Grantees/components/Teraco";
import Ihub from "./components/Grantees/components/Ihub";
import Impact from "./components/Impact";

const theme = createTheme({
  typography: {
    fontFamily: {
      fontFamily: "Nunito Sans",
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <div className="App">
          <Switch>
            <Route exact path="/case-study-ihub-kenya" component={Ihub} />
            <Route
              exact
              path="/case-study-teraco-data-environments"
              component={Teraco}
            />
            <Route exact path="/case-study-twiga-foods" component={Twiga} />
            <Route exact path="/contact-us" component={Contact} />
            <Route exact path="/impact" component={Impact} />
            <Route exact path="/for-grantees" component={Grantees} />
            <Route exact path="/for-funders" component={Funder} />
            <Route exact path="/the-fund" component={About} />
            <Route exact path="/" component={Home} />
          </Switch>
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
